import React, { useMemo } from "react";
import { useDispatch } from "react-redux";
import addToCart from "../../../../img/icons/addtoMyAnalog.svg";
import externalRedirect from "../../../../img/icons/externalRedirect.svg";
import * as EVENTS from "../../../../constants/config/dtm";
import { GENERIC_TOKEN, PRODUCT_DATASHEET_URL, PRODUCT_URL } from "../../../../constants/config/parts";
import { track } from "../../../../actions/dtm";
import * as PARAMETERS from "../../../../constants/config/parameters";
import PropTypes from "prop-types";
import localization from "../../../../data/config";
import { AddMyAnalogModalIcon } from "../../../AddToMyAnalogIcon/AddToMyAnalogIcon";
import "./style.css";
import { AddToMyCartIcon } from "../../../AddToMyCartIcon/AddToMyCartIcon";

/**
 * @name ProductCard
 * @function
 * @description Display Product Card for Mobile Devices
 * @returns {JSX}
 * @param {*} props
 */
const ProductCard = (props) => {
  const { partData, parameters } = props;
  const dispatch = useDispatch();
  
  // Getting title value of "1Ku List Price"
  const priceTitle = useMemo(() => {
    return parameters.find((item) => item.id === PARAMETERS.ONE_KU_PRICE_LIST);
  }, [parameters]);

  const hasDataSheet = useMemo(() => {
    return !Object.hasOwn(partData[PARAMETERS.PART_META], 'hasDataSheet') || partData[PARAMETERS.PART_META].hasDataSheet;
  });

  return (
    <a
      className={"product__card__container"}
      onClick={() => dispatch(track(EVENTS.PRODUCT_VIEW))}
      href={PRODUCT_URL.replace(GENERIC_TOKEN, partData[PARAMETERS.PART_META].generic)}
      target="_blank"
      rel="noopener noreferrer"
    >
      <div className="product__card__details">
        <div className="product__card__details__header">
          <div className="header__titles">
            <div className="header__titles__main">
              {partData["0"].displayValue}
            </div>
            <div className="header__titles__subheader">
              {partData[PARAMETERS.STATUS]?.displayValue}
            </div>
          </div>
          <div className="header__buttons">
            <AddMyAnalogModalIcon
              className="header__buttons__add__icon"
              productID={partData["0"].generic}
              mobile
            />
            <AddToMyCartIcon url={PRODUCT_URL.replace(GENERIC_TOKEN, partData[PARAMETERS.PART_META].generic)} mobile />
          </div>
        </div>
        {hasDataSheet && (
          <div className="product__card__details__links">
            <div className="link__container">
              {/* <div className="link__container__type">{datasheet.Type}</div> */}
              <a
                href={PRODUCT_DATASHEET_URL.replace(GENERIC_TOKEN, partData[PARAMETERS.PART_META].generic)}
                target="_blank"
                className="link__container__text-icon"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="link__container__text">{localization.dataSheetsLabel}</div>
                <img
                  src={externalRedirect}
                  className="link__container__icon"
                  width="12"
                  height="12"
                  alt="redirect link icon"
                />
              </a>
              {/* <div className="link__container__size">{datasheet.Size}</div> */}
            </div>
        </div>
        )}
        
        <div className="product__card__details__footer">
          <div className="item__number">
            <div className="item__number__text">
              {localization.availabilityLabel}
            </div>
            <div className="item__number__value">
              {partData[PARAMETERS.INVENTORY]?.displayValue
                ? partData[PARAMETERS.INVENTORY].displayValue
                : "-"}
            </div>
          </div>
          <div className="item__price">
            <div className="item__price__text">{priceTitle ? priceTitle.name : localization.onekuListPriceLabel}</div>
            <div className="item__price__value">
              {partData[PARAMETERS.ONE_KU_PRICE_LIST]?.value[0]
                ? `${localization.startingFromLabel} $${parseFloat(
                    partData[PARAMETERS.ONE_KU_PRICE_LIST].value[0]
                  ).toFixed(2)}`
                : "-"}
            </div>
          </div>
        </div>
      </div>
    </a>
  );
};

ProductCard.propTypes = {
  partData: PropTypes.object.isRequired,
  parameters: PropTypes.arrayOf(PropTypes.object).isRequired,
};

ProductCard.defaultProps = {
  partData: {},
  parameters: [],
};

export default ProductCard;
